import styled from "@emotion/styled";
import { WordingKey } from "@typings/i18n-typings";
import { ResponsiveDeviceType, useDimensions } from "@ui/hooks/use-dimensions";
import { LongRegisterProgressionBar } from "@ui/pages/validate-professional-information/components/long-register-progression-bar";
import { ShortRegisterProgressionBar } from "@ui/pages/validate-professional-information/components/short-register-progression-bar";
import React from "react";

export enum ProfessionalInformationValidationSteps {
	INTRODUCTION = 0,
	PROFESSIONAL_INFORMATION = 1,
	IDENTITY_VERIFICATION = 2,
	DONE = 3,
}

interface ProgressionStep {
	step: ProfessionalInformationValidationSteps;
	label: WordingKey;
}

export const progressionStepsData = [
	{
		step: ProfessionalInformationValidationSteps.INTRODUCTION,
		label: "register.progressionBar.introduction",
	},
	{
		step: ProfessionalInformationValidationSteps.PROFESSIONAL_INFORMATION,
		label: "register.progressionBar.professionalInfo",
	},
	{
		step: ProfessionalInformationValidationSteps.IDENTITY_VERIFICATION,
		label: "register.progressionBar.identityVerification",
	},
	{
		step: ProfessionalInformationValidationSteps.DONE,
		label: "register.progressionBar.done",
	},
] satisfies ProgressionStep[];

interface RegisterProgressionBarProps {
	step?: ProfessionalInformationValidationSteps;
}

export const RegisterProgressionBar = ({ step }: RegisterProgressionBarProps): JSX.Element => {
	const { responsiveDeviceType } = useDimensions();

	return (
		<Container>
			{responsiveDeviceType === ResponsiveDeviceType.Desktop ? (
				<LongRegisterProgressionBar step={step} />
			) : (
				<ShortRegisterProgressionBar step={step} />
			)}
		</Container>
	);
};

const Container = styled.div`
	position: sticky;
	top: 0;
	left: 0;
	right: 0;
	z-index: 2;
	background-color: white;
`;
